import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import { FilterWrapper } from "./Style";
import FilterBox from "../../../../components/common/FilterBox";

const statusOptions = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "INACTIVE", value: "INACTIVE" },
];

const Filter = ({ onFilter }) => {
  const firstRun = React.useRef(true);
  const [filterValues, setFilterValues] = useState({
    productId: "",
    orgCode: "",
    status: null, // MUST be null, not ""
  });

  const [debounceTimer, setDebounceTimer] = useState(null);

  const filterForm = [
    {
      name: "productId",
      type: "text",
      placeholder: "Search by Product Code",
      value: filterValues.productId,
    },
    {
      name: "orgCode",
      type: "text",
      placeholder: "Search by Org Code",
      value: filterValues.orgCode,
    },

    // ✅ SELECT MUST GET OPTION OBJECT
    {
      name: "status",
      type: "select",
      placeholder: "Select Status",
      value: statusOptions.find((o) => o.value === filterValues.status) || null,
      options: statusOptions,
    },
  ];

  // Debounce + call parent onFilter
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return; // ⛔ skip first auto-call
    }
    if (debounceTimer) clearTimeout(debounceTimer);

    const timer = setTimeout(() => {
      onFilter?.({
        productId: filterValues.productId?.trim() || null,
        orgCode: filterValues.orgCode?.trim() || null,
        status: filterValues.status || null, // extract pure value
        pageNo: 0,
        pageSize: 10,
      });
    }, 500);

    setDebounceTimer(timer);
    return () => clearTimeout(timer);
  }, [filterValues]);

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <FilterWrapper>
          <FilterBox
            filterForm={filterForm}
            onFilterChange={(value, index) => {
              const field = filterForm[index].name;

              if (field === "status") {
                // value is the selected option object from React-Select
                setFilterValues((prev) => ({
                  ...prev,
                  status: value ? value.value : null, // store raw value
                }));
                return;
              }

              // Normal text inputs
              setFilterValues((prev) => ({
                ...prev,
                [field]: value.target.value,
              }));
            }}
            onFilterSubmit={(e) => e.preventDefault()}
            className="transactionfilter"
            buttonValue=""
          />
        </FilterWrapper>
      </Box>
    </div>
  );
};

export default Filter;
